import type { Signature } from "../../models/signature";
import { DataTable, type DataTableProps } from "../datatable/DataTable";

type SignatureTableProps = {
  signatures: Signature[];
} & Required<
  Pick<DataTableProps<Signature>, "onEdit" | "onDelete" | "onSortStatusChange" | "sortStatus" | "pagination" | "onPageChange" | "fetching">
>;

export function SignatureTable({ signatures, ...props }: SignatureTableProps) {
  return (
    <DataTable
      records={signatures}
      columns={[
        {
          accessor: "first_name",
          title: "Vorname",
          sortable: true,
        },
        {
          accessor: "last_name",
          title: "Nachname",
          sortable: true,
        },
        {
          accessor: "email",
          title: "E-Mail",
          sortable: true,
        },
        {
          accessor: "position",
          title: "Position",
          sortable: true,
        },
      ]}
      {...props}
    />
  );
}
